<script setup>
    import { useLayout } from '@/layout/composables/layout';
    import { ref, computed } from 'vue';
    import AppConfig from '@/layout/AppConfig.vue';
    import InputText from 'primevue/inputtext';
    import Password from 'primevue/password';
    import Checkbox from 'primevue/checkbox';
    import Button from 'primevue/button';
    import Message from 'primevue/message';
    import Store from '../store';
    import Router from '../router';
    import api from '../lib/serverApi';
    import dialogs from '../lib/dialogs';

    const { layoutConfig } = useLayout();
    const login = ref('');
    const password = ref('');
    const checked = ref(false);
    const loginError = ref(false);

    const logoUrl = computed(() => {
        return `layout/images/${layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.svg`;
    });

    async function onSigIn() {
        try {
            loginError.value = false;
            const sessionData = await api.login(login.value, password.value)
            if (sessionData) {
                api.setSessionData(sessionData);
                const userData = await api.getUserData();
                Store.commit('SET_SESSIONDATA', { login: login.value, sessionData });
                Store.commit('SET_USERDATA', userData);
                Router.push('/App');
            } else loginError.value = true;
        } catch (error) {
            await dialogs.showError(error.message);
        }
    }
</script>

<template>
    <div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <div class="flex flex-column align-items-center justify-content-center" @keyup.enter="onSigIn">
            <img :src="logoUrl" class="mb-5 w-6rem flex-shrink-0" />
            <div>
                <div v-focustrap class="w-full surface-card py-6 px-5 sm:px-8">
                    <Message v-if="loginError" severity="error" :closable="false">
                        Неправильное имя пользователя или пароль
                    </Message>
                    <div>
                        <label for="login1" class="block text-900 text-xl font-medium mb-2">Имя</label>
                        <InputText
                            v-model="login"
                            type="text"
                            class="w-full md:w-30rem mb-5"
                            style="padding: 1rem"
                            autofocus
                        />

                        <label for="password1" class="block text-900 font-medium text-xl mb-2">Пароль</label>
                        <Password
                            v-model="password"
                            :toggleMask="true"
                            class="w-full mb-3"
                            inputClass="w-full"
                            inputStyle="padding:1rem"
                            :feedback="false"
                        />

                        <div class="flex align-items-center justify-content-between mb-5 gap-5">
                            <div class="flex align-items-center">
                                <Checkbox v-model="checked" id="rememberme1" binary class="mr-2"></Checkbox>
                                <label for="rememberme1">Запомнить меня</label>
                            </div>
                            <a class="font-medium no-underline ml-2 text-right cursor-pointer" style="color: var(--primary-color)">Забыли пароль?</a>
                        </div>
                        <Button label="Вход" class="w-full p-3 text-xl" @click="onSigIn"></Button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <AppConfig simple />
</template>

<style scoped>
.pi-eye {
    transform: scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform: scale(1.6);
    margin-right: 1rem;
}
</style>
